import { X_SCALE_VALUE, Y_SCALE_VALUE } from 'constants/map';
import { Direction } from 'types';
import { Indicator } from '../../types';
import { getDirection } from '../utils';

const OFFSET_CENTER = 6;
const X_INDICATOR_OFFSET_ON_LEFT_DIRECTION = X_SCALE_VALUE / 2 + 14;
const X_INDICATOR_OFFSET_ON_RIGHT_DIRECTION = X_SCALE_VALUE / 2 - 14;
const Y_INDICATOR_OFFSET_ON_SINGLE_DISTANCE = Y_SCALE_VALUE / 2 - 4;
const Y_INDICATOR_OFFSET_ON_MULTIPLE_DISTANCE = Y_SCALE_VALUE / 2 - 28;
const Y_INDICATOR_OFFSET_ON_DOWN_TURN = Y_SCALE_VALUE / 2 - 38;
const Y_INDICATOR_OFFSET_ON_UP_TURN = Y_SCALE_VALUE / 2 - 14;

const isTurn = (path: { x: number; y: number }[], index: number) => {
    const current = path[index];
    const previous = path[index - 1];
    const next = path[index + 1];

    if (!previous || !next || !current) return false;

    const direction = getDirection({ source: previous, target: current });
    const nextDirection = getDirection({ source: current, target: next });

    return direction.x !== nextDirection.x || direction.y !== nextDirection.y;
};

export const getIndicators = (path: { x: number; y: number }[]): Indicator[] => {
    const indicators: Indicator[] = [];

    // Indicators for source and target on different axis
    path.forEach((point, index) => {
        if (index === 0) return;

        const source = path[index - 1];
        const target = point;
        const direction = getDirection({ source, target });

        if (direction.y !== 0 && index % 2 === 0) {
            const offset = isTurn(path, index - 1)
                ? direction.y === 1
                    ? Y_INDICATOR_OFFSET_ON_DOWN_TURN
                    : Y_INDICATOR_OFFSET_ON_UP_TURN
                : path.length === 3
                ? Y_INDICATOR_OFFSET_ON_SINGLE_DISTANCE
                : Y_INDICATOR_OFFSET_ON_MULTIPLE_DISTANCE;
            indicators.push({
                x: target.x + OFFSET_CENTER,
                y: direction.y === 1 ? target.y - offset : target.y + offset,
                type: direction.y === 1 ? Direction.DOWN : Direction.UP
            });
        }

        if (direction.x !== 0 && index % 2 === 1 && !isTurn(path, index - 1)) {
            indicators.push({
                x: direction.x === 1 ? target.x - X_INDICATOR_OFFSET_ON_RIGHT_DIRECTION : target.x + X_INDICATOR_OFFSET_ON_LEFT_DIRECTION,
                y: target.y + OFFSET_CENTER,
                type: direction.x === 1 ? Direction.RIGHT : Direction.LEFT
            });
        }
    });

    return indicators;
};
